<template>
  <div>
    <Breadcrumbs main="Список пользователей" title="Список пользователей"/>
    <b-card>
      <div class="d-flex align-items-center mb-4">
        <SearchInput v-model="searchValue" @search="applySearch" :placeholder-name="searchPlaceholder"/>
        <b-form-select
            v-model="searchField"
            :options="searchFieldOptions"
            size="sm"
            class="ml-2"
            style="width: 220px"
        ></b-form-select>
      </div>
      <div v-if="isLoadingUsers" class="loading-wrapper">
        <b-spinner class="spinner"></b-spinner>
      </div>
      <b-table
          v-else
          responsive
          show-empty
          stacked="md"
          :striped="striped"
          :bordered="bordered"
          :fields="fields"
          :items="users"
          :current-page=0
          :per-page=10
          class="mb-5"
      >
        <template #cell(login)="data">
          <div>{{ data.item?.username ? data.item?.username : 'не указано' }}</div>
        </template>
        <template #cell(pubg_nick)="data">
          <div>{{ Array.isArray(data.item?.gameProfiles) && data.item.gameProfiles[0]?.fields?.nick || 'не указано' }}</div>
        </template>
        <template #cell(pubg_id)="data">
          <div>{{Array.isArray(data.item?.gameProfiles) && data.item?.gameProfiles?.[0]?.fields?.pubg_id || 'не указано' }}</div>
<!--          <div>{{ data.item?.gameProfiles?.[0]?.fields ? data.item.gameProfiles?.[0]?.fields?.pubg_id : 'не указано' }}</div>-->
        </template>
        <template #cell(status)="data">
          <div>
            <div v-if="data.item?.gameProfiles?.length <= 0">Не игровой/</div>
            <div v-else>Игровой/</div>
          </div>
          <div>
            <div v-if="data.item?.verified_social_accounts_count <= 0">Не активирован/</div>
            <div v-else>Активирован</div>
          </div>
        </template>
        <template #cell(country)="data">
          <div>{{ data.item.country ? data.item?.country?.name : 'не указано' }}</div>
        </template>
        <template #cell(action)="data">
          <b-btn
              type="submit"
              variant="primary"
              @click.prevent="
                                storeTeamMember({
                                    teamId:$route.params.id,
                                    userId:data.item.id,
                                    roleId:2
                                })"
              :id="'addPlayer' + data.item.id"
          >
            Добавить игрока
          </b-btn>
        </template>
      </b-table>

      <b-col md="6" class="p-0">
        <b-pagination
            @change="handlePageChange"
            v-model="currentPage"
            :total-rows="totalUserPagination"
            :per-page="10"
            class="my-0"
        ></b-pagination>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {UsersAdapterMixin} from "@/mixins/Users/UsersAdapterMixin";
import {ModalAdapterMixin} from "@/mixins/modal/ModalAdapterMixin";
import {PaginationHelperMixin} from "@/mixins/Helpers/PaginationHelperMixin";
import {TeamsAdapterMixin} from "@/mixins/Teams/TeamsAdapterMixin";
import SearchInput from "@/components/SearchInput.vue";

const SEARCH_FIELD_OPTIONS = [
  {value: 'id', text: 'По ID'},
  {value: 'username', text: 'По username'},
  {value: 'email', text: 'По email'},
  {value: 'teams.name', text: 'По команде'},
  {value: 'game_profile_game_id', text: 'По Game ID (PUBG/MLBB)'},
  {value: 'game_profile_nick', text: 'По игровому нику'},
  {value: 'social_account_username', text: 'По соц. аккаунту'},
]

const SEARCH_PLACEHOLDERS = {
  id: 'Введите ID пользователя',
  username: 'Введите username',
  email: 'Введите email',
  'teams.name': 'Введите название команды',
  game_profile_game_id: 'Введите PUBG ID или MLBB ID',
  game_profile_nick: 'Введите игровой ник',
  social_account_username: 'Введите username соц. аккаунта',
}

export default {
  name: "ListUsers",
  components: {SearchInput},
  mixins: [UsersAdapterMixin, ModalAdapterMixin, PaginationHelperMixin, TeamsAdapterMixin],
  mounted() {
    (async () => {
      try {
        this.isLoadingUsers = true
        this.recordPageToStorage(this.currentPage, this.pageKey)
        await this.grabUsers(this.buildRequestParams(this.getCurrentPageNumber(this.pageKey)))
      } finally {
        this.isLoadingUsers = false
      }
    })()
  },
  data() {
    return {
      searchValue: '',
      searchField: 'username',
      searchFieldOptions: SEARCH_FIELD_OPTIONS,
      pageKey: 'pageNumberAddPlayer',
      fields: [
        {key: 'id', label: '№', sortable: true,},
        {key: 'login', label: 'Логин', sortable: true,},
        {key: 'pubg_nick', label: 'Pubg nick', sortable: true,},
        {key: 'pubg_id', label: 'Pubg id', sortable: true,},
        {key: 'status', label: 'Статус', sortable: true,},
        {key: 'country', label: 'Страна', sortable: true,},
        {key: 'action', label: 'Просмотр', sortable: true,},
      ],
      striped: true,
      bordered: true,
      isLoadingUsers: false
    }
  },
  computed: {
    searchPlaceholder() {
      return SEARCH_PLACEHOLDERS[this.searchField] || 'Поиск пользователей'
    },
  },
  methods: {
    buildRequestParams(pageNumber) {
      const params = {
        pageNumber,
        filters: {},
      }
      if (this.searchValue) {
        params.filters[this.searchField] = this.searchValue
      }
      return params
    },
    handlePageChange(pageNumber) {
      this.recordPageToStorage(pageNumber, this.pageKey)
      this.isLoadingUsers = true
      this.grabUsers(this.buildRequestParams(pageNumber)).finally(() => {
        this.isLoadingUsers = false
      })
    },
    applySearch() {
      this.isLoadingUsers = true
      this.grabUsers(this.buildRequestParams(1)).finally(() => {
        this.isLoadingUsers = false
      })
    },
  },
}
</script>
